function ctrl($scope, Global, timeFormat, $location, getData, fetchStream, socketIo, $http, settings, $window) {
    $scope.global = Global;
    this.settings = settings;

    // connect to socket
    let socketConnect = () => {
        this.socket = io.connect(api+'/api/general_network/lateral_map', {
            secure: true,
            query: 'token=' + $window.sessionStorage.token,
            forceNew: true
        });

        let time = {};
        if ($location.$$search.start) {
            time.start = $location.$$search.start;
        }
        if ($location.$$search.end) {
            time.end = $location.$$search.end;
        }
        this.socket.emit('lateral_nodes', [])
        this.socket.emit('lateral_connections', time)
    }
    socketConnect();

    // saves the group and type of the node
    this.saveNodeInfo = function (type, group, update_list, new_nodes) {
        $http({
            method: 'POST',
            url: api+'/api/general_network/lateral_map/save_node_info',
            data: {
                type : type,
                group : group,
                update_list : update_list,
                new_nodes : new_nodes,
            }
        }).success(function () {
        }).error(function () {
            console.log("error")
        })
    }

    // saves the ALL the associated nodes once an already created group is edited or deleted
    this.editAssociatedGroups = function (nodes, group) {
        $http({
            method: 'POST',
            url: api+'/api/general_network/lateral_map/edit_associated_groups',
            data: {
                nodes : nodes,
                group : group,
            }
        }).success(function () {
        }).error(function () {
            console.log("error")
        })
    }

    // create/edit group (name, color)
    this.createEditGroup = function (group, callback) {
        $http({
            method: 'POST',
            url: api+'/api/general_network/lateral_map/create_edit_group',
            data: {
                id : group.id,
                color : group.color,
                name : group.name,
            }
        }).success(function (data) {
            callback(data)
        }).error(function () {
            console.log("error")
        })
    }

    // delete group
    this.deleteGroup = function (id) {
        $http({
            method: 'POST',
            url: api+'/api/general_network/lateral_map/delete_group',
            data: {
                id : id,
            }
        }).success(function () {
        }).error(function () {
            console.log("error")
        })
    }

    // get all group
    this.getGroups = () => {
        $http({
            method: 'GET',
            url: api+'/api/general_network/lateral_map/get_groups',
        }).success(data => {
            this.setGroups(data);
        }).error(error => {
            console.log("error")
        })
    }
    this.getGroups();

    $scope.$on('$destroy', () => {
        if (this.socket) {
            this.socket.disconnect();
        }
    });
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$location', 'getData', 'fetchStream', 'socketIo', '$http', 'settings', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/lateral_map.js
 **/